<form [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <div class="space-y-md">
    <label class="mt-xs font-bold">{{ t('createJobRequest.solarInstallation.desiredSystem.label') }}</label>
    <cft-radio [formControl]="form.controls.desiredSystem | bgoAsFormControl" [value]="DesiredSystem.RoofPhotovoltaic">
      {{ t('createJobRequest.solarInstallation.desiredSystem.roofMounted') }}
    </cft-radio>
    <cft-radio
      [formControl]="form.controls.desiredSystem | bgoAsFormControl"
      [value]="DesiredSystem.Other"
      [hasWarning]="form.controls.desiredSystem.value === DesiredSystem.Other"
    >
      {{ t('createJobRequest.solarInstallation.desiredSystem.other') }}
    </cft-radio>
    @if (form.controls.desiredSystem.value === DesiredSystem.Other) {
      <span class="warning">{{ t('createJobRequest.solarInstallation.desiredSystem.otherWarning') }}</span>
    }
    @if (form.controls.desiredSystem.value === DesiredSystem.Other) {
      <cft-form-field>
        <label for="otherDesiredSystem"> {{ t('createJobRequest.solarInstallation.desiredSystem.otherLabel') }}</label>
        <input
          id="otherDesiredSystem"
          type="text"
          [formControl]="form.controls.otherDesiredSystem | bgoAsFormControl"
          data-testid="otherSystemInput"
        />
      </cft-form-field>
    }
  </div>

  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.desiredSystem.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.solarInstallation.roofSquareMeters.label') }}</label>
    <span class="block text-sm text-grey-700">
      {{ t('createJobRequest.solarInstallation.roofSquareMeters.hint') }}
    </span>
    <cft-number-input
      [formControl]="form.controls.roofSquareMeters | bgoAsFormControl"
      [step]="5"
      [min]="0"
      [hasWarning]="form.controls.roofSquareMeters.value > 100"
    />
    @if (form.controls.roofSquareMeters.invalid && form.controls.roofSquareMeters.touched) {
      <div class="mt-xs error">{{ t('createJobRequest.solarInstallation.roofSquareMeters.error') }}</div>
    } @else if (form.controls.roofSquareMeters.value > 100) {
      <span class="warning">{{ t('createJobRequest.solarInstallation.roofSquareMeters.tooBig') }}</span>
    }
  </div>

  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.roofSquareMeters.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.solarInstallation.addons.label') }}</label>
    @for (control of (form.controls.addons | bgoAsFormArray).controls; track $index) {
      <cft-checkbox [formControl]="control | bgoAsFormControl">
        {{ t('createJobRequest.solarInstallation.addons.' + AddonValues[$index]) }}
      </cft-checkbox>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-sm" [class.gradual-reveal-hidden]="form.controls.roofSquareMeters.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.solarInstallation.buildingType.label') }}</label>
    <cft-form-field>
      <label for="buildingType">
        {{ t('createJobRequest.solarInstallation.buildingType.control') }}
      </label>
      <cft-select
        id="buildingType"
        [formControl]="form.controls.buildingType | bgoAsFormControl"
        [items]="BuildingTypeOptions"
      />
    </cft-form-field>
    @if (form.controls.buildingType.value === BuildingType.Other) {
      <cft-form-field>
        <label for="otherType">{{ t('createJobRequest.solarInstallation.desiredSystem.otherLabel') }}</label>
        <input
          id="otherType"
          type="text"
          [formControl]="form.controls.otherBuildingType | bgoAsFormControl"
          data-testid="otherTypeInput"
        />
      </cft-form-field>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.buildingType.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.solarInstallation.importanceFactor.label') }}</label>
    @for (factor of ImportanceFactorValues; track $index) {
      <cft-radio [formControl]="form.controls.mostImportantFactor | bgoAsFormControl" [value]="factor">
        {{ t('createJobRequest.solarInstallation.importanceFactor.' + factor) }}
      </cft-radio>
    }
  </div>
</form>
